import i18n from '@/i18n'
import axios from 'axios'
import { apiV3Segment } from '../../shared/constants'
import { ErrorUtils } from '../../utils/errorUtils'

const getDefaultState = () => {
  return {
    networks: [],
    networks_loaded: false,
    shared_networks: [],
    shared_networks_loaded: false,
    network_usage: null
  }
}

const state = getDefaultState()

export default {
  state,
  getters: {
    getNetworks: state => {
      return state.networks
    },
    getNetworksLoaded: state => {
      return state.networks_loaded
    },
    getSharedNetworks: state => {
      return state.shared_networks
    },
    getSharedNetworksLoaded: state => {
      return state.shared_networks_loaded
    },
    getNetworkUsage: state => {
      return state.network_usage
    }
  },
  mutations: {
    resetNetworksState: (state) => {
      Object.assign(state, getDefaultState())
    },
    setNetworks: (state, networks) => {
      state.networks = networks
      state.networks_loaded = true
    },
    setSharedNetworks: (state, networks) => {
      state.shared_networks = networks
      state.shared_networks_loaded = true
    },
    add_networks: (state, network) => {
      state.networks = [...state.networks, network]
    },
    update_networks: (state, network) => {
      const item = state.networks.find(n => n.id === network.id)
      if (item) {
        Object.assign(item, network)
      }
    },
    remove_networks: (state, network) => {
      const networkIndex = state.networks.findIndex(n => n.id === network.id)
      if (networkIndex !== -1) {
        state.networks.splice(networkIndex, 1)
      }
    },
    setNetworkUsage: (state, usage) => {
      state.network_usage = usage
    }
  },
  actions: {
    resetNetworksState (context) {
      context.commit('resetNetworksState')
    },
    fetchNetworks (context) {
      return axios.get(`${apiV3Segment}/user/networks`).then(response => {
        const userId = context.rootGetters.getUser.user_id
        const owned = response.data.filter(n => n.user === userId)
        const shared = response.data.filter(n => n.user !== userId)
        context.commit('setNetworks', owned)
        context.commit('setSharedNetworks', shared)
      }).catch(e => {
        ErrorUtils.handleErrors(e, this._vm.$snotify)
      })
    },
    createNetwork (context, payload) {
      ErrorUtils.showInfoMessage(this._vm.$snotify, i18n.t('messages.info.creating-network'), '', true, 1000)
      return axios.post(`${apiV3Segment}/user/networks`, payload).then(response => {
        context.commit('add_networks', response.data)
        ErrorUtils.showInfoMessage(this._vm.$snotify, i18n.t('messages.info.network-created'), '', false, 2000)
        return response.data
      }).catch(e => {
        ErrorUtils.handleErrors(e, this._vm.$snotify)
        throw e
      })
    },
    updateNetwork (context, { id, data }) {
      return axios.put(`${apiV3Segment}/user/networks/${id}`, data).then(response => {
        context.commit('update_networks', response.data)
        ErrorUtils.showInfoMessage(this._vm.$snotify, i18n.t('messages.info.network-updated'), '', false, 2000)
        return response.data
      }).catch(e => {
        ErrorUtils.handleErrors(e, this._vm.$snotify)
        throw e
      })
    },
    deleteNetwork (context, networkId) {
      return axios.delete(`${apiV3Segment}/user/networks/${networkId}`).then(() => {
        context.commit('remove_networks', { id: networkId })
        ErrorUtils.showInfoMessage(this._vm.$snotify, i18n.t('messages.info.network-deleted'), '', false, 2000)
      }).catch(e => {
        ErrorUtils.handleErrors(e, this._vm.$snotify)
        throw e
      })
    },
    fetchNetworkUsage (context, networkId) {
      return axios.get(`${apiV3Segment}/user/networks/${networkId}/usage`).then(response => {
        context.commit('setNetworkUsage', response.data)
        return response.data
      }).catch(e => {
        ErrorUtils.handleErrors(e, this._vm.$snotify)
        throw e
      })
    }
  }
}
